module.exports = __webpack_public_path__ + "9788f41e/img/revit-icon.5ff0d581.svg";